import React, {  useEffect } from 'react';
import MetaTitle from '../components/MetaTitle';
import { Link, useNavigate } from 'react-router-dom';
import "../assete/css/about.css";
import Header from './Header';
import team_pic_1 from "../assete/About//about-2.jpg";
import bext_pic_ad from "../assete/icon/best 2.png";
import supp_pic_ad from "../assete/icon/supp 1.png";
import frnd_pic_ad from "../assete/icon/fried 1.png"; 
import history_pic from "../assete/newimages/history.jpg";
import Footer from './Footer';
import about_vdo from "../assete/newimages/about.jpg";
import new_design_pic_2 from "../assete/newimages/medium-shot-graduate-student.png";
import AOS from "aos";
import "aos/dist/aos.css";
import Scrolltop from './Scrolltop';
 import Whatsapp from './Whatsapp';
 import about_new_design_1 from "../assete/newimages/about 4.png";
 import circle_pic from "../assete/newimages/dot-circle.png";
 import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
 import { faPhone } from "@fortawesome/free-solid-svg-icons";
 import about_two_pic from "../assete/newimages/about-two-image2.png";

const About = () => {
    useEffect(() => {
        AOS.init({
            duration:600,
            delay:300
        });
      }, []);

      const navigate = useNavigate();

      const phd_peoposal = () => {
        navigate("");
       
        
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      };


   
      
  return (
    <>

  
   <MetaTitle title={"About | "} description="Find the best place to guide your research works at an affordable price. Visit Sea Sense Interdisciplinary Research and IT Solution (OPC) Pvt.Ltd. for PhD guidance."
   
        keywords="PhD guidance in Marthandam |
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |
Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships |
Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari |
PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |
Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu |
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |
Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil |
PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |
Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum |
PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey |
PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |
Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai |
PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |
Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai |
PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |
Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy |
PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |
Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli |
PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |
Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore |
PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india |
PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |
Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam |
PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |
Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin |
PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |
Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam |
PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |
Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |"/>

    <Header/>
  <div className='seasense_web_about_div'>
    <img src={about_vdo} alt=""/> 

        <div className="about_content" >
    <h1 data-aos="zoom-in" data-aos-duration="2000">About Us</h1>
    </div>
        </div> 
<div className='new_padding_div'>
<div className='seasense_about_new_main_div'>
    <div className='seasense_about_new_main_div_1'>
        <div className='seasense_about_new_main_div_2'>
            <img src={circle_pic} alt="" className='cirle_pic' />
            <h3>About Company</h3>
            <h1>Empowering businesses through technology</h1>
            <p>In today’s fast-paced digital landscape, technology has become more than just a tool—it’s the backbone of successful businesses. As the business environment becomes increasingly complex and competitive, leveraging the right technologies allows organizations to streamline their operations, improve decision-making, and boost productivity. Whether it’s through automation, data-driven insights, or innovative solutions, technology enables businesses to optimize internal processes, enhance customer experiences, and drive growth. At Sea Sense, we specialize in providing businesses with cutting-edge technological solutions that not only improve efficiency but also position them ahead of the competition.</p>

            <div className='seasense_about_new_main_div_3'>
                <div className='seasense_about_new_main_div_4'>
                    <h2>Software Development</h2>
                    <p>Software development is at the heart of today’s technological revolution, playing a critical role in driving innovation across industries.</p>
                </div>
                <div className='seasense_about_new_main_div_5'>
                <h2>Mobile Development</h2>
                <p>Mobile development is a dynamic field that focuses on creating applications for mobile devices, such as smartphones and tablets.  </p>
                </div>
            </div>
            <div className='seasense_about_new_main_div_6'>
            <h3>Call Now :</h3>
                    <h2> <FontAwesomeIcon icon={faPhone} /> +91-85 26 700 700</h2>
                    <h2><FontAwesomeIcon icon={faPhone} /> 1800 5726 426 </h2>
            </div>
        </div>
<div className='seasense_about_new_main_div_pic'>
    <img src={about_new_design_1} alt=""/>
</div>

    </div>
</div>
</div>
 
        <div className='about_new_design_web'>
 <div className='about_best_assissent_div'>
            <div className='about_best_div_2' data-aos="fade-up" data-aos-duration="2000">
                <h2>Best <em>Research Assistance</em> In India</h2>
                <h3>Sea Sense Research</h3>
                
                <p>Sea Sense is a top Research Assistance service in India, known for its excellent support for academics in doctorate research. Our team has experienced Research professionals with diverse academic backgrounds. Each scholar acquires specific instructions for their field of study. Sea Sense provides comprehensive support project implementation and research papers, which includes developing research proposal, building methodologies and preparing manuscripts for publication. We prioritize high standards in data analysis. Our researchers use various methods to ensure accurate study results. Sea Sense is proud of researchers who have submitted their Thesis and achieved publication, advancing their academic careers. Sea Sense is a reliable academic advisor who values confidentiality and transparency. Clients could reach out to us to schedule a consultation for customized professional advice that meets their research needs.</p>
            </div>
            <div className='about_best_assissent_div_1'>
                <img src={about_two_pic} alt="" />
            </div>
        </div>  
        </div>
<div className='about_new_design_div'>
    <div className='about_new_design_div_1'>
        <div className='new_back_design_pic_add'>
        <div className='about_new_design_div_2'>
            <img src={new_design_pic_2} alt=""/>
        </div>
        </div>
        <div className='about_new_design_div_2_content'>
            <div className='about_new_design_div_2_content_1'>
                <h2>Seasense Research</h2>
                <p> Whether you're formulating a research question, conducting a thorough literature review, or developing a strong research methodology, our experts ensure you stay on the right track. We assist with data collection and analysis, helping you apply appropriate statistical tools and qualitative methods. Our services include thesis writing, editing, and formatting, ensuring compliance with university guidelines. If you’re preparing for your dissertation defense, we provide mock sessions and constructive feedback to enhance your confidence. Additionally, we offer journal publication assistance, helping you with manuscript preparation, peer review responses, and high-impact journal submissions. Our tailored guidance ensures academic success, making your PhD journey smooth and stress-free.</p>
            </div>
        </div>
    </div>
</div>
<div className='seasense_new_design_pic'>
 <div className='seasense_about_expert'>
    <div className='seasense_about_expert_1'>
        <div className='seasense_about_expert_2'>
            <h1>High-Quality Work Experiences</h1>
        </div>
        <div className='seasense_about_expert_conts'>
            <h2>Welcome to Sea Sense Research, where we empower scholars with expert support and guidance. Our services include research proposal development, literature review assistance, data analysis, manuscript preparation and academic coaching.</h2>
        </div>
        <div className='seasense_about_expert_btn'>
            <button><Link to="/Contact"  onClick={phd_peoposal}>Contact</Link></button>
        </div>
    </div>
</div>   
</div>
<div className='new_padding_div_2'>
 <div className='seasense_web_about_short'>
    <div className='seasense_short_history'>
        <div className='seasense_short_history_1'>
            <img src={history_pic} alt="" />
        </div>
        <div className='history_short_conts' data-aos="zoom-in" data-aos-duration="2000">
           
            <h2>SHORT HISTORY</h2>
            <p>Welcome to Sea Sense Research! For the past 10 years, Sea Sense has been a trusted provider of PhD guidance and software development services. Our team of expert staff offers specialized assistance, ensuring our clients receive top-tier support throughout their academic and software development journeys. With extensive experience in both fields, we pride ourselves on delivering expert guidance tailored to individual needs. Our commitment to quality and client satisfaction has earned us a reputation for excellence. Numerous clients have successfully completed their PhD programs and projects with our help, expressing high satisfaction with our services. Sea Sense continues to be a reliable partner for those seeking expert guidance and innovative software solutions. At Sea Sense Research, we are committed to fostering academic excellence and have facilitated the publication of over 1,500 research papers. Our state-of-the-art cloud datacenter ensures secure and reliable storage and management of research data, while our advanced cloud services cater to a wide range of academic needs.Our dedication goes beyond just offering services—we aim to build long-lasting relationships with researchers, scholars, and institutions by providing ongoing support throughout their academic careers. Whether you're looking for guidance on your PhD research, need assistance with data analysis, or require customized software development for your research, Sea Sense is here to help you unlock your full potential.</p>
        </div>
    </div>
</div>   
</div>
<div className='about_seasense_design_new'>
  <div className='about_best_main_div'>
  
    <div className='about_best_div'>
        <div className='about_best_div_1'>
            <div className='about_best_pic'>
                <img src={bext_pic_ad} alt="" loading="lazy"/>
            </div>
            <h2>Best Strategy</h2>
            <p>Sea Sense offers tailored strategies combining innovative methodologies and proven techniques for Research success.</p>
        </div>
        <div className='about_best_div_1'>
        <div className='about_best_pic'>
                <img src={supp_pic_ad} alt="" loading="lazy"/>
            </div>
            <h2>High-Quality Services</h2>
            <p>Sea Sense delivers top-notch services, including meticulous proofreading and insightful feedback.</p>
        </div>
        <div className='about_best_div_1'>
        <div className='about_best_pic'>
                <img src={frnd_pic_ad} alt="" loading="lazy"/>
            </div>
            <h2>Friendly Support</h2>
            <p>For over a decade, Sea Sense has provided personalized and friendly guidance for Research.</p>
        </div>
    </div>
</div> 
</div>
 <div className='about_team_main_div'>
    <div className='about_team_div'>
        <div className='about_team_div_1' data-aos="fade-down" data-aos-duration="2000">
           
            <h2>Our Team</h2>
            <p>Our team is dedicated to driving innovation and delivering impactful research solutions. With diverse experience across various academic and industrial domains, we are passionate about turning complex challenges into opportunities for discovery and growth. Each member of our team contributes unique insights and skills, ensuring excellence in every project. In addition to our technical proficiency, we place great emphasis on providing exceptional support throughout the research journey. From the early stages of conceptualization to the final stages of implementation, we ensure that our clients have access to the resources and guidance necessary to achieve success. </p>
        </div>
        <div className='team_about_pic'>
            <img src={team_pic_1} alt="" data-aos="fade-up" data-aos-duration="2000" loading="lazy"/>
        </div>
    </div>
</div>  

<div className='company_principal_main_div'>
    <div className='company_principal_main_div_conts'>
    <h2>Company Principles</h2>
    <p>We believe in making the maximal use of Technology for rendering the best to our Research Scholars at different levels.</p>
        </div>
    <div className='company_principal_main_div_1'>
        <div className='company_principal_main_div_2'>
        <h2>Commitment</h2>
        <p>Sea Sense strongly believes in the principles of commitment as it builds a bridge for long term Relations.</p>
        </div>
        <div className='company_principal_main_div_2'>
        <h2>Diligence</h2>
                    <p>We have a reputation of being enthusiastic as we appreciate that no mission could be reached without dedication.</p>
        </div>
        <div className='company_principal_main_div_2'>
        <h2>Excellence</h2>
                    <p>It is enormously crucial to be ambitious for the growth. So, we believe in perfection which makes us laudable and different from others.</p>
        </div>
    </div>
</div>



  <Whatsapp/> 
<Scrolltop/>
<Footer/>

    </>
  )
}

export default About